import UserProfile from '@/entities/UserProfile';
import axios from 'axios';

const ls = require('local-storage');

export default {
  async sendMagicLink(email) {
    const res = await axios.get(process.env.VUE_APP_REQUEST_SHOP_MAGIC_LINK_ENDPOINT, {
      params: {
        callbackURL: process.env.VUE_APP_MAGIC_LINK_CALLBACK_ENDPOINT,
        email,
      },
    });
    return res;
  },
  async listAllUsers() {
    const url = process.env.VUE_APP_LIST_USERS_ENDPOINT;
    const shopToken = ls.get('shopToken');

    const { data } = await axios.get(url, { headers: { 'shop-token': shopToken } });

    const users = data.map((user) => new UserProfile(user));

    return users;
  },

  async loginWithMagicLinkToken(token) {
    return Promise.resolve(ls.set('shopToken', token));
  },

  async logout() {
    return Promise.resolve(ls.unsetShopToken('shopToken'));
  },
};
